module.exports = __webpack_public_path__ + "static/media/banner@2x.6cf66823.png";